import { useState } from "react";
import axios from "axios";
import {
	DatasetsClient,
	ScoringClient,
	CareClient,
	UsersClient,
	ModulesClient,
	TripInspectionClient,
	AssessmentClient,
	ImpiricaUserClient,
	OrganizationClient,
	TrainingCourseClient,
	ClientTrainingClient,
	FileManagementClient,
	BillingClient,
	AuditLogClient,
	NeurapulseClient,
	CustomFieldValueClient,
} from "../@types/ImpiricaPlatformApi";
import StreamingClient from "./CustomClients/StreamingClient";

export type ApiClients = {
	datasetsClient?: DatasetsClient;
	scoringClient?: ScoringClient;
	careClient?: CareClient;
	usersClient?: UsersClient;
	modulesClient?: ModulesClient;
	tripInspectionClient?: TripInspectionClient;
	assessmentClient?: AssessmentClient;
	impiricaUserClient?: ImpiricaUserClient;
	organizationClient?: OrganizationClient;
	trainingCourseClient?: TrainingCourseClient;
	clientTrainingClient?: ClientTrainingClient;
	fileManagementClient?: FileManagementClient;
	billingClient?: BillingClient;
	auditLogClient?: AuditLogClient;
	neurapulseClient?: NeurapulseClient;
	customFieldValueClient?: CustomFieldValueClient;
	streamingClient?: StreamingClient;
};

export const useApi = () => {
	if (!process.env.REACT_APP_API_URI) throw new Error("API URI not set");

	const baseURL = new URL(process.env.REACT_APP_API_URI, window.location.origin)
		.href;
	const axiosClient = axios.create({
		baseURL,
		headers: {
			"X-CSRF": "1",
		},
	});
	const [datasetsClient] = useState<DatasetsClient>(
		new DatasetsClient(baseURL, axiosClient)
	);
	const [scoringClient] = useState<ScoringClient>(
		new ScoringClient(baseURL, axiosClient)
	);
	const [careClient] = useState<CareClient>(
		new CareClient(baseURL, axiosClient)
	);
	const [usersClient] = useState<UsersClient>(
		new UsersClient(baseURL, axiosClient)
	);
	const [modulesClient] = useState<ModulesClient>(
		new ModulesClient(baseURL, axiosClient)
	);
	const [tripInspectionClient] = useState<TripInspectionClient>(
		new TripInspectionClient(baseURL, axiosClient)
	);
	const [assessmentClient] = useState<AssessmentClient>(
		new AssessmentClient(baseURL, axiosClient)
	);
	const [impiricaUserClient] = useState<ImpiricaUserClient>(
		new ImpiricaUserClient(baseURL, axiosClient)
	);
	const [organizationClient] = useState<OrganizationClient>(
		new OrganizationClient(baseURL, axiosClient)
	);
	const [trainingCourseClient] = useState<TrainingCourseClient>(
		new TrainingCourseClient(baseURL, axiosClient)
	);
	const [clientTrainingClient] = useState<ClientTrainingClient>(
		new ClientTrainingClient(baseURL, axiosClient)
	);
	const [fileManagementClient] = useState<FileManagementClient>(
		new FileManagementClient(baseURL, axiosClient)
	);
	const [billingClient] = useState<BillingClient>(
		new BillingClient(baseURL, axiosClient)
	);
	const [auditLogClient] = useState<AuditLogClient>(
		new AuditLogClient(baseURL, axiosClient)
	);
	const [neurapulseClient] = useState<NeurapulseClient>(
		new NeurapulseClient(baseURL, axiosClient)
	);
	const [customFieldValueClient] = useState<CustomFieldValueClient>(
		new CustomFieldValueClient(baseURL, axiosClient)
	);
	const [streamingClient] = useState<StreamingClient>(
		new StreamingClient(baseURL, axiosClient)
	);

	const clients: ApiClients = {
		datasetsClient,
		scoringClient,
		careClient,
		usersClient,
		modulesClient,
		tripInspectionClient,
		assessmentClient,
		impiricaUserClient,
		organizationClient,
		trainingCourseClient,
		clientTrainingClient,
		fileManagementClient,
		billingClient,
		auditLogClient,
		neurapulseClient,
		customFieldValueClient,
		streamingClient,
	};
	return clients;
};
